import { render, staticRenderFns } from "./VulnDbAnalyzer.vue?vue&type=template&id=626877a1&"
import script from "./VulnDbAnalyzer.vue?vue&type=script&lang=js&"
export * from "./VulnDbAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports